import { User } from '@clearkit/icons';

import { PageLayout } from '~/components/PageLayout';
import { UserAccountSettings } from '~/components/profile/UserAccountSettings';

export const PageGeneralAccount = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <User />
      </PageLayout.Tile>
      <PageLayout.Heading>Account</PageLayout.Heading>
      <PageLayout.SubHeading>
        Manage your user account settings
      </PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <UserAccountSettings />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
